module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    class: _vm.spanclass
  }, [_c('div', {
    staticClass: "border-bg-rollover center-flex",
    class: _vm.ratioclass
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c7309d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/rollover_card.vue
// module id = 622
// module chunks = 1